<script setup lang="ts">
import { title } from 'process';

    const { status, signIn } = useAuth();

    const isReady = ref(false);
    const badgesData = ref([] as any);
    const userRankData = ref([] as any);

    const openModal = (type: string, src: string, description: string) => {

        const id01 = document.getElementById('id01');
        const modalImage = document.getElementById('modal-image');
        const modalDesc = document.getElementById('modal-desc');

        id01 ? id01.style.display='block' : null;
        modalImage ? modalImage.setAttribute('src', src) : null;
        modalDesc ? modalDesc.innerHTML = description : null;

    }


    onMounted(async () => {
        isReady.value = true;
        if (status.value === 'authenticated') {
            loadUserRank().catch((e) => {
                console.log("Error al cargar el usuario", e);
            });
            loadBadgesData().catch((e) => {
                console.log("Error al cargar los datos de los logros", e);
            });
        }
    })

    const loadUserRank = async () => {
        try {
            const response: any = await $fetch('/api/strapi/badges/badge-rank');
            userRankData.value = response;
            console.log(response);
        } catch (e) {
            console.log(e);
        }
    }

    const loadBadgesData = async () => {
        try {
            const response: any = await $fetch('/api/strapi/badges/get-badges');
            badgesData.value = response;
            console.log(response);
        } catch (e) {
            console.log(e);
        }
    }

</script>

<template>
    <div>
        <Head>
            <Title>Logros</Title>
            <Meta name="description" :content="'Logros'" />
        </Head>
        
        <div v-if="isReady" class="main-container">
            <div v-if="status === 'authenticated'">

                <div id="id01" class="w3-modal">
                    <div class="w3-modal-content" style="max-width: 600px;">
                        <div class="w3-container" style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
                            <span onclick="document.getElementById('id01').style.display='none'" class="w3-button w3-display-topright">&times;</span>
                            <img style="width:80%" id="modal-image" src="" />
                            <p id="modal-desc" style="font-size: 16px;text-align: justify;padding: 23px;"></p>
                        </div>
                    </div>
                </div>

                <div class="cnt-user-rankig">

                    <div class="badge-box">
                        <div class="badge-main">
                            <img v-if="userRankData.userRankBadge" width="250" :src="userRankData.userRankBadge.Image.url" :alt="userRankData.userRankBadge.Name" class="image">
                            <svg v-else style="width:250;height:100px;" role="img" height="100px" width="250px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000" data-v-inspector="components/Header.vue:98:37" data-v-a81738bd=""><g id="SVGRepo_bgCarrier" stroke-width="0" data-v-inspector="components/Header.vue:98:274" data-v-a81738bd=""></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" data-v-inspector="components/Header.vue:98:321" data-v-a81738bd=""></g><g id="SVGRepo_iconCarrier" data-v-inspector="components/Header.vue:98:402" data-v-a81738bd=""><g data-v-inspector="components/Header.vue:98:431" data-v-a81738bd=""><g data-v-inspector="components/Header.vue:98:435" data-v-a81738bd=""><path style="fill:#930B1F;" d="M379.586,52.966l-35.31,52.966h8.828v35.31h35.31v132.326c2.807-1.156,5.597-2.348,8.289-3.725 c24.135-12.332,42.161-34.039,52.224-59.207L512,52.966H379.586z" data-v-inspector="components/Header.vue:98:439" data-v-a81738bd=""></path> <path style="fill:#930B1F;" d="M123.586,141.241h35.31v-35.31h8.828l-35.31-52.966H0l63.073,157.67 c10.063,25.167,28.089,46.874,52.224,59.207c2.692,1.377,5.482,2.569,8.289,3.725V141.241z" data-v-inspector="components/Header.vue:98:634" data-v-a81738bd=""></path></g> <path style="fill:#F8D832;" d="M388.414,370.759L256,459.034l-132.414-88.276V141.241h35.31v-35.31h194.207v35.31h35.31V370.759z" data-v-inspector="components/Header.vue:98:833" data-v-a81738bd=""></path> <path style="fill:#C4A316;" d="M158.897,351.862L256,416.595l97.103-64.733V176.555h-35.31v-35.31H194.207v35.31h-35.31V351.862z" data-v-inspector="components/Header.vue:98:968" data-v-a81738bd=""></path> <g data-v-inspector="components/Header.vue:98:1103" data-v-a81738bd=""><path style="fill:#6B0F21;" d="M61.793,79.448H14.124c-1.156,0-2.251,0.256-3.266,0.662l6.797,16.993h44.138 c4.873,0,8.828-3.955,8.828-8.828C70.621,83.403,66.666,79.448,61.793,79.448" data-v-inspector="components/Header.vue:98:1107" data-v-a81738bd=""></path> <path style="fill:#6B0F21;" d="M70.621,114.759H28.248c-1.156,0-2.251,0.256-3.266,0.662l6.797,16.993h38.841 c4.873,0,8.828-3.955,8.828-8.828C79.448,118.713,75.494,114.759,70.621,114.759" data-v-inspector="components/Header.vue:98:1297" data-v-a81738bd=""></path> <path style="fill:#6B0F21;" d="M88.276,150.069H42.372c-1.156,0-2.251,0.256-3.266,0.662l6.797,16.993h42.372 c4.873,0,8.828-3.955,8.828-8.828C97.103,154.024,93.149,150.069,88.276,150.069" data-v-inspector="components/Header.vue:98:1491" data-v-a81738bd=""></path> <path style="fill:#6B0F21;" d="M497.879,79.448H450.21c-4.882,0-8.828,3.955-8.828,8.828c0,4.873,3.946,8.828,8.828,8.828h44.138 l6.797-16.993C500.13,79.704,499.036,79.448,497.879,79.448" data-v-inspector="components/Header.vue:98:1685" data-v-a81738bd=""></path> <path style="fill:#6B0F21;" d="M487.019,115.418c-1.015-0.406-2.11-0.662-3.266-0.662H441.38c-4.882,0-8.828,3.955-8.828,8.828 c0,4.882,3.946,8.828,8.828,8.828h38.841L487.019,115.418z" data-v-inspector="components/Header.vue:98:1878" data-v-a81738bd=""></path> <path style="fill:#6B0F21;" d="M466.097,167.724l6.797-16.993c-1.015-0.406-2.11-0.662-3.266-0.662h-45.903 c-4.882,0-8.828,3.955-8.828,8.828c0,4.873,3.946,8.828,8.828,8.828H466.097z" data-v-inspector="components/Header.vue:98:2068" data-v-a81738bd=""></path></g></g></g></svg>
                            <div class="badge-data" >
                                <span class="position">Rank #{{ userRankData.rankPosition || 0 }} <span class="total-players" v-if="userRankData.totalUsers >= 2"> / {{ userRankData.totalUsers }}</span> </span>
                                <span v-if="userRankData.userRankBadge">{{ userRankData.userRankBadge.Name }}</span>
                                <span v-else>Bronce I</span>
                                <span>{{ userRankData.totalPoints || 0}} pts</span> 
                                
                            </div>  
                        </div>
                        <div class="badge-info" v-if="userRankData.tagBadges && userRankData.tagBadges.length > 0">
                           
                            <div class="container">
                                <div class="image-item" v-for="otherBadge in userRankData.tagBadges">
                                    <img width="100" :src="otherBadge.Image.url" :alt="otherBadge.Name">
                                    <div class="popup">{{ otherBadge.Name }}</div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    
                    <p style="text-align: justify">
                        ¡Bienvenido a tus logros! Aquí es donde tus hazañas y habilidades periodísticas se convierten en honorables distinciones. Has llegado al lugar donde cada clic, cada artículo y cada aporte se transforman en insignias brillantes que celebran tu camino.
                        Navega por tus medallas con orgullo, cada una de ellas cuenta una historia de dedicación y pasión por el periodismo. Desde los primeros pasos hasta los grandes hitos, este es tu espacio para ver cómo tu esfuerzo y compromiso se materializan. ¡Así que explora, presume y sigue coleccionando logros mientras haces del mundo un lugar más informado!
                        <br><br>
                        Aquí te mostramos dos tablas con todas las insignias que puedes conseguir. Hay insignias de lectura que se obtienen al leer artículos e insignias de etiquetas que se obtienen al leer artículos con etiquetas específicas.
                    </p>
                </div>
                <div class="badge-grid">
                    <div class="badge-column">
                        <table class="badge-table">
                            <thead>
                                <tr>
                                    <th>Imagen</th>
                                    <th>Nombre</th>
                                    <th>Puntos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="badge in badgesData" >
                                    <tr v-if="badge.Type === 'Read'" @click="openModal('image', badge.Image && badge.Image.url, badge.Description)">
                                        <td class="image"><img :src="badge.Image.url" alt="Insignia 1"></td>
                                        <td>{{ badge.Name }}</td>
                                        
                                        <td>{{ badge.PointsNeeded }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                    
                    <div class="badge-column">
                        <table class="badge-table">
                            <thead>
                                <tr>
                                    <th>Imagen</th>
                                    <th>Nombre</th>
                                    <th>Puntos</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="badge in badgesData" >
                                    <tr v-if="badge.Type === 'Tag'" @click="openModal('image', badge.Image && badge.Image.url, badge.Description)">
                                        <td class="image"><img :src="badge.Image.url"></td>
                                        <td>{{ badge.Name }}</td>
                                        
                                        <td>{{ badge.PointsNeeded }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div v-if="status === 'unauthenticated'">
                
                <div class="only-members">Solo para miembros registrados</div>
                <p style="text-align:justify;word-spacing: 1px;">
                    ¿Listo para un desafío que haga vibrar tu mente? Únete a nuestro sistema de insignias y demuestra que tu red de información va más allá de Twitter. Regístrate y empieza a coleccionar nuestras medallas como si se tratara de un videojuego, pero con el añadido de que, en lugar de salvar un mundo ficticio, estarás disfrutando de una dosis diaria de noticias. ¡Piensa en ello como un videojuego donde el objetivo es informarte!
                </p>
                <a href="/suscripcion" class="members-signup">Regístrate pulsando aquí</a>
                
            </div>
        </div>
        <div v-else class="spinner">
            <Spinner />
        </div>
    </div>
</template>

<style>
.mfp-bg {
    opacity: 0.96;
}

.mfp-close-btn-in .mfp-close {
    color: white;
}
</style>

<style scoped>

th {
    font-size: 14px;
    width: 100px;
    font-weight: 400;
}

td {
    cursor: pointer;
    font-size: 14px;
}


.only-members {
    padding: 8px 20px 8px 20px;
    background-color: #3f908a;
    color: white;
    text-align: center;
    font-size: 23px;
}

.cnt-user-rankig {
    display: flex;
    flex-direction: column;
}

.main-container {
    display: flex;
    padding: 0px 300px 0px 300px;
}

@media (max-width: 1200px) {
    .badge-table img {
        width: 70px !important;
    }
    .main-container {
        display: flex;
        padding: 50px 25px 0px 25px;
    }
}


table {
    width: 100%;
    margin-top: 0px;
}

.badge-grid {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
}

.badge-column {
    background-color: #f8f8f8; /* Fondo diferente para cada columna */
    
    border-radius: 10px; /* Bordes redondeados para cada columna */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* Sombra alrededor de cada columna */
}

.badge-column h2 {
    text-align: center;
    margin-bottom: 10px;
    font-size: 1.5em;
    color: #555;
}

.badge-table {
    border-collapse: collapse;
    margin-bottom: 0;
}

.badge-table th, .badge-table td {
    text-align: center;
    border-bottom: none;
}

.badge-table th {
    background-color: #3f908a; /* Color de fondo verde para la cabecera */
    color: white; /* Texto en blanco para mejor contraste */
    font-weight: bold;
}

.badge-table tr:hover {
    background-color: #f1f1f1;
}

.badge-table img {
    width: 100px;
    border-radius: 50%;
}

@media (max-width: 768px) {
    .badge-grid {
        flex-direction: column;
        align-items: center;
        gap: 20px;
    }
}

/* Image Overlay */
.image-container {
    position: relative;
    display: inline-block;
}

.image {
    padding: 15px;
    display: block;
}

.overlay-text {
    position: absolute;
    bottom: 10;
    background: rgba(0, 0, 0, 0.7); /* Fondo semi-transparente */
    color: white;
    width: 100%;
    text-align: center;
    padding: 10px 0;
    font-size: 10px;
    opacity: 0; /* Inicialmente oculto */
    transition: opacity 0.3s ease; /* Efecto de transición */
}

.image-container:hover .overlay-text {
    opacity: 1; /* Mostrar texto al pasar el ratón */
}


/* Badge CSS */
.badge-box {
  display: flex;
  align-items: center;
  background-color: #f4f4f4;
  border-radius: 8px;
  padding: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 100%;
  min-width: 80%;
  margin: 20px auto;
  flex-wrap: wrap;
    gap: 20px;
    align-items: center;
    justify-content: center;
}

.badge-main {
  display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.badge-main .badge-title {
    margin: 0px;
    color:#3f908a;
    font-weight: 600;
    letter-spacing: 2px;
}

.badge-main img {
  border-radius: 50%;
}

.badge-info {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}

.badge-data {
    display:flex;
    flex-direction:column;
    align-items: flex-start;
    justify-content: center;
}

.badge-data span {
    color:#3f908a;
    font-weight: 600;
    letter-spacing: 2px;
}

.badge-data .position {
    font-size: 30px;
    align-self: center;
}

.badge-data .total-players {
    font-size: 15px;
}

.position,
.points {
  margin: 0;
  font-size: 16px;
  color: #333;
}

.secondary-badges {
  display: flex;
  gap: 5px; /* Espacio entre las insignias secundarias */
}

.secondary-badges img {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}




/* Prueba */

.container {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    max-width: 800px;
    align-items: center;
    justify-content: center;
}

.image-item {
    position: relative;
    overflow: hidden;
    width: 100px;
    height: 100px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
}

.image-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 10px;
}

.image-item .popup {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px;
    text-align: center;
    opacity: 0;
    transform: translateY(100%);
    transition: opacity 0.3s ease, transform 0.3s ease;
    border-radius: 0 0 10px 10px;
    font-size: 12px;
}

.image-item:hover {
    transform: scale(1.05);
}

.image-item:hover .popup {
    opacity: 1;
    transform: translateY(0);
}







/* W3.CSS 4.15 December 2020 by Jan Egil and Borge Refsnes */
html{box-sizing:border-box}*,*:before,*:after{box-sizing:inherit}
/* Extract from normalize.css by Nicolas Gallagher and Jonathan Neal git.io/normalize */
html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}
article,aside,details,figcaption,figure,footer,header,main,menu,nav,section{display:block}summary{display:list-item}
audio,canvas,progress,video{display:inline-block}progress{vertical-align:baseline}
audio:not([controls]){display:none;height:0}[hidden],template{display:none}
a{background-color:transparent}a:active,a:hover{outline-width:0}
abbr[title]{border-bottom:none;text-decoration:underline;text-decoration:underline dotted}
b,strong{font-weight:bolder}dfn{font-style:italic}mark{background:#ff0;color:#000}
small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}
sub{bottom:-0.25em}sup{top:-0.5em}figure{margin:1em 40px}img{border-style:none}
code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}hr{box-sizing:content-box;height:0;overflow:visible}
button,input,select,textarea,optgroup{font:inherit;margin:0}optgroup{font-weight:bold}
button,input{overflow:visible}button,select{text-transform:none}
button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button}
button::-moz-focus-inner,[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner{border-style:none;padding:0}
button:-moz-focusring,[type=button]:-moz-focusring,[type=reset]:-moz-focusring,[type=submit]:-moz-focusring{outline:1px dotted ButtonText}
fieldset{border:1px solid #c0c0c0;margin:0 2px;padding:.35em .625em .75em}
legend{color:inherit;display:table;max-width:100%;padding:0;white-space:normal}textarea{overflow:auto}
[type=checkbox],[type=radio]{padding:0}
[type=number]::-webkit-inner-spin-button,[type=number]::-webkit-outer-spin-button{height:auto}
[type=search]{-webkit-appearance:textfield;outline-offset:-2px}
[type=search]::-webkit-search-decoration{-webkit-appearance:none}
::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}
/* End extract */
html,body{font-family:Verdana,sans-serif;font-size:15px;line-height:1.5}html{overflow-x:hidden}
h1{font-size:36px}h2{font-size:30px}h3{font-size:24px}h4{font-size:20px}h5{font-size:18px}h6{font-size:16px}
.w3-serif{font-family:serif}.w3-sans-serif{font-family:sans-serif}.w3-cursive{font-family:cursive}.w3-monospace{font-family:monospace}
h1,h2,h3,h4,h5,h6{font-family:"Segoe UI",Arial,sans-serif;font-weight:400;margin:10px 0}.w3-wide{letter-spacing:4px}
hr{border:0;border-top:1px solid #eee;margin:20px 0}
.w3-image{max-width:100%;height:auto}img{vertical-align:middle}a{color:inherit}
.w3-table,.w3-table-all{border-collapse:collapse;border-spacing:0;width:100%;display:table}.w3-table-all{border:1px solid #ccc}
.w3-bordered tr,.w3-table-all tr{border-bottom:1px solid #ddd}.w3-striped tbody tr:nth-child(even){background-color:#f1f1f1}
.w3-table-all tr:nth-child(odd){background-color:#fff}.w3-table-all tr:nth-child(even){background-color:#f1f1f1}
.w3-hoverable tbody tr:hover,.w3-ul.w3-hoverable li:hover{background-color:#ccc}.w3-centered tr th,.w3-centered tr td{text-align:center}
.w3-table td,.w3-table th,.w3-table-all td,.w3-table-all th{padding:8px 8px;display:table-cell;text-align:left;vertical-align:top}
.w3-table th:first-child,.w3-table td:first-child,.w3-table-all th:first-child,.w3-table-all td:first-child{padding-left:16px}
.w3-btn,.w3-button{border:none;display:inline-block;padding:8px 16px;vertical-align:middle;overflow:hidden;text-decoration:none;color:inherit;background-color:inherit;text-align:center;cursor:pointer;white-space:nowrap}
.w3-btn:hover{box-shadow:0 8px 16px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19)}
.w3-btn,.w3-button{-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}   
.w3-disabled,.w3-btn:disabled,.w3-button:disabled{cursor:not-allowed;opacity:0.3}.w3-disabled *,:disabled *{pointer-events:none}
.w3-btn.w3-disabled:hover,.w3-btn:disabled:hover{box-shadow:none}
.w3-badge,.w3-tag{background-color:#000;color:#fff;display:inline-block;padding-left:8px;padding-right:8px;text-align:center}.w3-badge{border-radius:50%}
.w3-ul{list-style-type:none;padding:0;margin:0}.w3-ul li{padding:8px 16px;border-bottom:1px solid #ddd}.w3-ul li:last-child{border-bottom:none}
.w3-tooltip,.w3-display-container{position:relative}.w3-tooltip .w3-text{display:none}.w3-tooltip:hover .w3-text{display:inline-block}
.w3-ripple:active{opacity:0.5}.w3-ripple{transition:opacity 0s}
.w3-input{padding:8px;display:block;border:none;border-bottom:1px solid #ccc;width:100%}
.w3-select{padding:9px 0;width:100%;border:none;border-bottom:1px solid #ccc}
.w3-dropdown-click,.w3-dropdown-hover{position:relative;display:inline-block;cursor:pointer}
.w3-dropdown-hover:hover .w3-dropdown-content{display:block}
.w3-dropdown-hover:first-child,.w3-dropdown-click:hover{background-color:#ccc;color:#000}
.w3-dropdown-hover:hover > .w3-button:first-child,.w3-dropdown-click:hover > .w3-button:first-child{background-color:#ccc;color:#000}
.w3-dropdown-content{cursor:auto;color:#000;background-color:#fff;display:none;position:absolute;min-width:160px;margin:0;padding:0;z-index:1}
.w3-check,.w3-radio{width:24px;height:24px;position:relative;top:6px}
.w3-sidebar{height:100%;width:200px;background-color:#fff;position:fixed!important;z-index:1;overflow:auto}
.w3-bar-block .w3-dropdown-hover,.w3-bar-block .w3-dropdown-click{width:100%}
.w3-bar-block .w3-dropdown-hover .w3-dropdown-content,.w3-bar-block .w3-dropdown-click .w3-dropdown-content{min-width:100%}
.w3-bar-block .w3-dropdown-hover .w3-button,.w3-bar-block .w3-dropdown-click .w3-button{width:100%;text-align:left;padding:8px 16px}
.w3-main,#main{transition:margin-left .4s}
.w3-modal{z-index:3;display:none;padding-top:100px;position:fixed;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgb(0,0,0);background-color:rgba(0,0,0,0.4)}
.w3-modal-content{margin:auto;background-color:#fff;position:relative;padding:0;outline:0;width:600px}
.w3-bar{width:100%;overflow:hidden}.w3-center .w3-bar{display:inline-block;width:auto}
.w3-bar .w3-bar-item{padding:8px 16px;float:left;width:auto;border:none;display:block;outline:0}
.w3-bar .w3-dropdown-hover,.w3-bar .w3-dropdown-click{position:static;float:left}
.w3-bar .w3-button{white-space:normal}
.w3-bar-block .w3-bar-item{width:100%;display:block;padding:8px 16px;text-align:left;border:none;white-space:normal;float:none;outline:0}
.w3-bar-block.w3-center .w3-bar-item{text-align:center}.w3-block{display:block;width:100%}
.w3-responsive{display:block;overflow-x:auto}
.w3-container:after,.w3-container:before,.w3-panel:after,.w3-panel:before,.w3-row:after,.w3-row:before,.w3-row-padding:after,.w3-row-padding:before,
.w3-cell-row:before,.w3-cell-row:after,.w3-clear:after,.w3-clear:before,.w3-bar:before,.w3-bar:after{content:"";display:table;clear:both}
.w3-col,.w3-half,.w3-third,.w3-twothird,.w3-threequarter,.w3-quarter{float:left;width:100%}
.w3-col.s1{width:8.33333%}.w3-col.s2{width:16.66666%}.w3-col.s3{width:24.99999%}.w3-col.s4{width:33.33333%}
.w3-col.s5{width:41.66666%}.w3-col.s6{width:49.99999%}.w3-col.s7{width:58.33333%}.w3-col.s8{width:66.66666%}
.w3-col.s9{width:74.99999%}.w3-col.s10{width:83.33333%}.w3-col.s11{width:91.66666%}.w3-col.s12{width:99.99999%}
@media (min-width:601px){.w3-col.m1{width:8.33333%}.w3-col.m2{width:16.66666%}.w3-col.m3,.w3-quarter{width:24.99999%}.w3-col.m4,.w3-third{width:33.33333%}
.w3-col.m5{width:41.66666%}.w3-col.m6,.w3-half{width:49.99999%}.w3-col.m7{width:58.33333%}.w3-col.m8,.w3-twothird{width:66.66666%}
.w3-col.m9,.w3-threequarter{width:74.99999%}.w3-col.m10{width:83.33333%}.w3-col.m11{width:91.66666%}.w3-col.m12{width:99.99999%}}
@media (min-width:993px){.w3-col.l1{width:8.33333%}.w3-col.l2{width:16.66666%}.w3-col.l3{width:24.99999%}.w3-col.l4{width:33.33333%}
.w3-col.l5{width:41.66666%}.w3-col.l6{width:49.99999%}.w3-col.l7{width:58.33333%}.w3-col.l8{width:66.66666%}
.w3-col.l9{width:74.99999%}.w3-col.l10{width:83.33333%}.w3-col.l11{width:91.66666%}.w3-col.l12{width:99.99999%}}
.w3-rest{overflow:hidden}.w3-stretch{margin-left:-16px;margin-right:-16px}
.w3-content,.w3-auto{margin-left:auto;margin-right:auto}.w3-content{max-width:980px}.w3-auto{max-width:1140px}
.w3-cell-row{display:table;width:100%}.w3-cell{display:table-cell}
.w3-cell-top{vertical-align:top}.w3-cell-middle{vertical-align:middle}.w3-cell-bottom{vertical-align:bottom}
.w3-hide{display:none!important}.w3-show-block,.w3-show{display:block!important}.w3-show-inline-block{display:inline-block!important}
@media (max-width:1205px){.w3-auto{max-width:95%}}
@media (max-width:600px){.w3-modal-content{margin:0 10px;width:auto!important}.w3-modal{padding-top:30px}
.w3-dropdown-hover.w3-mobile .w3-dropdown-content,.w3-dropdown-click.w3-mobile .w3-dropdown-content{position:relative}	
.w3-hide-small{display:none!important}.w3-mobile{display:block;width:100%!important}.w3-bar-item.w3-mobile,.w3-dropdown-hover.w3-mobile,.w3-dropdown-click.w3-mobile{text-align:center}
.w3-dropdown-hover.w3-mobile,.w3-dropdown-hover.w3-mobile .w3-btn,.w3-dropdown-hover.w3-mobile .w3-button,.w3-dropdown-click.w3-mobile,.w3-dropdown-click.w3-mobile .w3-btn,.w3-dropdown-click.w3-mobile .w3-button{width:100%}}
@media (max-width:768px){.w3-modal-content{width:500px}.w3-modal{padding-top:50px}}
@media (min-width:993px){.w3-modal-content{width:900px}.w3-hide-large{display:none!important}.w3-sidebar.w3-collapse{display:block!important}}
@media (max-width:992px) and (min-width:601px){.w3-hide-medium{display:none!important}}
@media (max-width:992px){.w3-sidebar.w3-collapse{display:none}.w3-main{margin-left:0!important;margin-right:0!important}.w3-auto{max-width:100%}}
.w3-top,.w3-bottom{position:fixed;width:100%;z-index:1}.w3-top{top:0}.w3-bottom{bottom:0}
.w3-overlay{position:fixed;display:none;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.5);z-index:2}
.w3-display-topleft{position:absolute;left:0;top:0}.w3-display-topright{position:absolute;right:0;top:0}
.w3-display-bottomleft{position:absolute;left:0;bottom:0}.w3-display-bottomright{position:absolute;right:0;bottom:0}
.w3-display-middle{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%)}
.w3-display-left{position:absolute;top:50%;left:0%;transform:translate(0%,-50%);-ms-transform:translate(-0%,-50%)}
.w3-display-right{position:absolute;top:50%;right:0%;transform:translate(0%,-50%);-ms-transform:translate(0%,-50%)}
.w3-display-topmiddle{position:absolute;left:50%;top:0;transform:translate(-50%,0%);-ms-transform:translate(-50%,0%)}
.w3-display-bottommiddle{position:absolute;left:50%;bottom:0;transform:translate(-50%,0%);-ms-transform:translate(-50%,0%)}
.w3-display-container:hover .w3-display-hover{display:block}.w3-display-container:hover span.w3-display-hover{display:inline-block}.w3-display-hover{display:none}
.w3-display-position{position:absolute}
.w3-circle{border-radius:50%}
.w3-round-small{border-radius:2px}.w3-round,.w3-round-medium{border-radius:4px}.w3-round-large{border-radius:8px}.w3-round-xlarge{border-radius:16px}.w3-round-xxlarge{border-radius:32px}
.w3-row-padding,.w3-row-padding>.w3-half,.w3-row-padding>.w3-third,.w3-row-padding>.w3-twothird,.w3-row-padding>.w3-threequarter,.w3-row-padding>.w3-quarter,.w3-row-padding>.w3-col{padding:0 8px}
.w3-container,.w3-panel{padding:0.01em 16px}.w3-panel{margin-top:16px;margin-bottom:16px}
.w3-code,.w3-codespan{font-family:Consolas,"courier new";font-size:16px}
.w3-code{width:auto;background-color:#fff;padding:8px 12px;border-left:4px solid #4CAF50;word-wrap:break-word}
.w3-codespan{color:crimson;background-color:#f1f1f1;padding-left:4px;padding-right:4px;font-size:110%}
.w3-card,.w3-card-2{box-shadow:0 2px 5px 0 rgba(0,0,0,0.16),0 2px 10px 0 rgba(0,0,0,0.12)}
.w3-card-4,.w3-hover-shadow:hover{box-shadow:0 4px 10px 0 rgba(0,0,0,0.2),0 4px 20px 0 rgba(0,0,0,0.19)}
.w3-spin{animation:w3-spin 2s infinite linear}@keyframes w3-spin{0%{transform:rotate(0deg)}100%{transform:rotate(359deg)}}
.w3-animate-fading{animation:fading 10s infinite}@keyframes fading{0%{opacity:0}50%{opacity:1}100%{opacity:0}}
.w3-animate-opacity{animation:opac 0.8s}@keyframes opac{from{opacity:0} to{opacity:1}}
.w3-animate-top{position:relative;animation:animatetop 0.4s}@keyframes animatetop{from{top:-300px;opacity:0} to{top:0;opacity:1}}
.w3-animate-left{position:relative;animation:animateleft 0.4s}@keyframes animateleft{from{left:-300px;opacity:0} to{left:0;opacity:1}}
.w3-animate-right{position:relative;animation:animateright 0.4s}@keyframes animateright{from{right:-300px;opacity:0} to{right:0;opacity:1}}
.w3-animate-bottom{position:relative;animation:animatebottom 0.4s}@keyframes animatebottom{from{bottom:-300px;opacity:0} to{bottom:0;opacity:1}}
.w3-animate-zoom {animation:animatezoom 0.6s}@keyframes animatezoom{from{transform:scale(0)} to{transform:scale(1)}}
.w3-animate-input{transition:width 0.4s ease-in-out}.w3-animate-input:focus{width:100%!important}
.w3-opacity,.w3-hover-opacity:hover{opacity:0.60}.w3-opacity-off,.w3-hover-opacity-off:hover{opacity:1}
.w3-opacity-max{opacity:0.25}.w3-opacity-min{opacity:0.75}
.w3-greyscale-max,.w3-grayscale-max,.w3-hover-greyscale:hover,.w3-hover-grayscale:hover{filter:grayscale(100%)}
.w3-greyscale,.w3-grayscale{filter:grayscale(75%)}.w3-greyscale-min,.w3-grayscale-min{filter:grayscale(50%)}
.w3-sepia{filter:sepia(75%)}.w3-sepia-max,.w3-hover-sepia:hover{filter:sepia(100%)}.w3-sepia-min{filter:sepia(50%)}
.w3-tiny{font-size:10px!important}.w3-small{font-size:12px!important}.w3-medium{font-size:15px!important}.w3-large{font-size:18px!important}
.w3-xlarge{font-size:24px!important}.w3-xxlarge{font-size:36px!important}.w3-xxxlarge{font-size:48px!important}.w3-jumbo{font-size:64px!important}
.w3-left-align{text-align:left!important}.w3-right-align{text-align:right!important}.w3-justify{text-align:justify!important}.w3-center{text-align:center!important}
.w3-border-0{border:0!important}.w3-border{border:1px solid #ccc!important}
.w3-border-top{border-top:1px solid #ccc!important}.w3-border-bottom{border-bottom:1px solid #ccc!important}
.w3-border-left{border-left:1px solid #ccc!important}.w3-border-right{border-right:1px solid #ccc!important}
.w3-topbar{border-top:6px solid #ccc!important}.w3-bottombar{border-bottom:6px solid #ccc!important}
.w3-leftbar{border-left:6px solid #ccc!important}.w3-rightbar{border-right:6px solid #ccc!important}
.w3-section,.w3-code{margin-top:16px!important;margin-bottom:16px!important}
.w3-margin{margin:16px!important}.w3-margin-top{margin-top:16px!important}.w3-margin-bottom{margin-bottom:16px!important}
.w3-margin-left{margin-left:16px!important}.w3-margin-right{margin-right:16px!important}
.w3-padding-small{padding:4px 8px!important}.w3-padding{padding:8px 16px!important}.w3-padding-large{padding:12px 24px!important}
.w3-padding-16{padding-top:16px!important;padding-bottom:16px!important}.w3-padding-24{padding-top:24px!important;padding-bottom:24px!important}
.w3-padding-32{padding-top:32px!important;padding-bottom:32px!important}.w3-padding-48{padding-top:48px!important;padding-bottom:48px!important}
.w3-padding-64{padding-top:64px!important;padding-bottom:64px!important}
.w3-padding-top-64{padding-top:64px!important}.w3-padding-top-48{padding-top:48px!important}
.w3-padding-top-32{padding-top:32px!important}.w3-padding-top-24{padding-top:24px!important}
.w3-left{float:left!important}.w3-right{float:right!important}
.w3-button:hover{color:#000!important;background-color:#ccc!important}
.w3-transparent,.w3-hover-none:hover{background-color:transparent!important}
.w3-hover-none:hover{box-shadow:none!important}
/* Colors */
.w3-amber,.w3-hover-amber:hover{color:#000!important;background-color:#ffc107!important}
.w3-aqua,.w3-hover-aqua:hover{color:#000!important;background-color:#00ffff!important}
.w3-blue,.w3-hover-blue:hover{color:#fff!important;background-color:#2196F3!important}
.w3-light-blue,.w3-hover-light-blue:hover{color:#000!important;background-color:#87CEEB!important}
.w3-brown,.w3-hover-brown:hover{color:#fff!important;background-color:#795548!important}
.w3-cyan,.w3-hover-cyan:hover{color:#000!important;background-color:#00bcd4!important}
.w3-blue-grey,.w3-hover-blue-grey:hover,.w3-blue-gray,.w3-hover-blue-gray:hover{color:#fff!important;background-color:#607d8b!important}
.w3-green,.w3-hover-green:hover{color:#fff!important;background-color:#4CAF50!important}
.w3-light-green,.w3-hover-light-green:hover{color:#000!important;background-color:#8bc34a!important}
.w3-indigo,.w3-hover-indigo:hover{color:#fff!important;background-color:#3f51b5!important}
.w3-khaki,.w3-hover-khaki:hover{color:#000!important;background-color:#f0e68c!important}
.w3-lime,.w3-hover-lime:hover{color:#000!important;background-color:#cddc39!important}
.w3-orange,.w3-hover-orange:hover{color:#000!important;background-color:#ff9800!important}
.w3-deep-orange,.w3-hover-deep-orange:hover{color:#fff!important;background-color:#ff5722!important}
.w3-pink,.w3-hover-pink:hover{color:#fff!important;background-color:#e91e63!important}
.w3-purple,.w3-hover-purple:hover{color:#fff!important;background-color:#9c27b0!important}
.w3-deep-purple,.w3-hover-deep-purple:hover{color:#fff!important;background-color:#673ab7!important}
.w3-red,.w3-hover-red:hover{color:#fff!important;background-color:#f44336!important}
.w3-sand,.w3-hover-sand:hover{color:#000!important;background-color:#fdf5e6!important}
.w3-teal,.w3-hover-teal:hover{color:#fff!important;background-color:#009688!important}
.w3-yellow,.w3-hover-yellow:hover{color:#000!important;background-color:#ffeb3b!important}
.w3-white,.w3-hover-white:hover{color:#000!important;background-color:#fff!important}
.w3-black,.w3-hover-black:hover{color:#fff!important;background-color:#000!important}
.w3-grey,.w3-hover-grey:hover,.w3-gray,.w3-hover-gray:hover{color:#000!important;background-color:#9e9e9e!important}
.w3-light-grey,.w3-hover-light-grey:hover,.w3-light-gray,.w3-hover-light-gray:hover{color:#000!important;background-color:#f1f1f1!important}
.w3-dark-grey,.w3-hover-dark-grey:hover,.w3-dark-gray,.w3-hover-dark-gray:hover{color:#fff!important;background-color:#616161!important}
.w3-pale-red,.w3-hover-pale-red:hover{color:#000!important;background-color:#ffdddd!important}
.w3-pale-green,.w3-hover-pale-green:hover{color:#000!important;background-color:#ddffdd!important}
.w3-pale-yellow,.w3-hover-pale-yellow:hover{color:#000!important;background-color:#ffffcc!important}
.w3-pale-blue,.w3-hover-pale-blue:hover{color:#000!important;background-color:#ddffff!important}
.w3-text-amber,.w3-hover-text-amber:hover{color:#ffc107!important}
.w3-text-aqua,.w3-hover-text-aqua:hover{color:#00ffff!important}
.w3-text-blue,.w3-hover-text-blue:hover{color:#2196F3!important}
.w3-text-light-blue,.w3-hover-text-light-blue:hover{color:#87CEEB!important}
.w3-text-brown,.w3-hover-text-brown:hover{color:#795548!important}
.w3-text-cyan,.w3-hover-text-cyan:hover{color:#00bcd4!important}
.w3-text-blue-grey,.w3-hover-text-blue-grey:hover,.w3-text-blue-gray,.w3-hover-text-blue-gray:hover{color:#607d8b!important}
.w3-text-green,.w3-hover-text-green:hover{color:#4CAF50!important}
.w3-text-light-green,.w3-hover-text-light-green:hover{color:#8bc34a!important}
.w3-text-indigo,.w3-hover-text-indigo:hover{color:#3f51b5!important}
.w3-text-khaki,.w3-hover-text-khaki:hover{color:#b4aa50!important}
.w3-text-lime,.w3-hover-text-lime:hover{color:#cddc39!important}
.w3-text-orange,.w3-hover-text-orange:hover{color:#ff9800!important}
.w3-text-deep-orange,.w3-hover-text-deep-orange:hover{color:#ff5722!important}
.w3-text-pink,.w3-hover-text-pink:hover{color:#e91e63!important}
.w3-text-purple,.w3-hover-text-purple:hover{color:#9c27b0!important}
.w3-text-deep-purple,.w3-hover-text-deep-purple:hover{color:#673ab7!important}
.w3-text-red,.w3-hover-text-red:hover{color:#f44336!important}
.w3-text-sand,.w3-hover-text-sand:hover{color:#fdf5e6!important}
.w3-text-teal,.w3-hover-text-teal:hover{color:#009688!important}
.w3-text-yellow,.w3-hover-text-yellow:hover{color:#d2be0e!important}
.w3-text-white,.w3-hover-text-white:hover{color:#fff!important}
.w3-text-black,.w3-hover-text-black:hover{color:#000!important}
.w3-text-grey,.w3-hover-text-grey:hover,.w3-text-gray,.w3-hover-text-gray:hover{color:#757575!important}
.w3-text-light-grey,.w3-hover-text-light-grey:hover,.w3-text-light-gray,.w3-hover-text-light-gray:hover{color:#f1f1f1!important}
.w3-text-dark-grey,.w3-hover-text-dark-grey:hover,.w3-text-dark-gray,.w3-hover-text-dark-gray:hover{color:#3a3a3a!important}
.w3-border-amber,.w3-hover-border-amber:hover{border-color:#ffc107!important}
.w3-border-aqua,.w3-hover-border-aqua:hover{border-color:#00ffff!important}
.w3-border-blue,.w3-hover-border-blue:hover{border-color:#2196F3!important}
.w3-border-light-blue,.w3-hover-border-light-blue:hover{border-color:#87CEEB!important}
.w3-border-brown,.w3-hover-border-brown:hover{border-color:#795548!important}
.w3-border-cyan,.w3-hover-border-cyan:hover{border-color:#00bcd4!important}
.w3-border-blue-grey,.w3-hover-border-blue-grey:hover,.w3-border-blue-gray,.w3-hover-border-blue-gray:hover{border-color:#607d8b!important}
.w3-border-green,.w3-hover-border-green:hover{border-color:#4CAF50!important}
.w3-border-light-green,.w3-hover-border-light-green:hover{border-color:#8bc34a!important}
.w3-border-indigo,.w3-hover-border-indigo:hover{border-color:#3f51b5!important}
.w3-border-khaki,.w3-hover-border-khaki:hover{border-color:#f0e68c!important}
.w3-border-lime,.w3-hover-border-lime:hover{border-color:#cddc39!important}
.w3-border-orange,.w3-hover-border-orange:hover{border-color:#ff9800!important}
.w3-border-deep-orange,.w3-hover-border-deep-orange:hover{border-color:#ff5722!important}
.w3-border-pink,.w3-hover-border-pink:hover{border-color:#e91e63!important}
.w3-border-purple,.w3-hover-border-purple:hover{border-color:#9c27b0!important}
.w3-border-deep-purple,.w3-hover-border-deep-purple:hover{border-color:#673ab7!important}
.w3-border-red,.w3-hover-border-red:hover{border-color:#f44336!important}
.w3-border-sand,.w3-hover-border-sand:hover{border-color:#fdf5e6!important}
.w3-border-teal,.w3-hover-border-teal:hover{border-color:#009688!important}
.w3-border-yellow,.w3-hover-border-yellow:hover{border-color:#ffeb3b!important}
.w3-border-white,.w3-hover-border-white:hover{border-color:#fff!important}
.w3-border-black,.w3-hover-border-black:hover{border-color:#000!important}
.w3-border-grey,.w3-hover-border-grey:hover,.w3-border-gray,.w3-hover-border-gray:hover{border-color:#9e9e9e!important}
.w3-border-light-grey,.w3-hover-border-light-grey:hover,.w3-border-light-gray,.w3-hover-border-light-gray:hover{border-color:#f1f1f1!important}
.w3-border-dark-grey,.w3-hover-border-dark-grey:hover,.w3-border-dark-gray,.w3-hover-border-dark-gray:hover{border-color:#616161!important}
.w3-border-pale-red,.w3-hover-border-pale-red:hover{border-color:#ffe7e7!important}.w3-border-pale-green,.w3-hover-border-pale-green:hover{border-color:#e7ffe7!important}
.w3-border-pale-yellow,.w3-hover-border-pale-yellow:hover{border-color:#ffffcc!important}.w3-border-pale-blue,.w3-hover-border-pale-blue:hover{border-color:#e7ffff!important}
</style>
